<template>
<div v-if="settings" class="mb-3">

		<NavigationItem 
			id="assessment"
			name="Reifegraderhebung" 
			icon="mdi-poll" 
			iconcolor="grey"
			description="Befragungsmodul Ihrer Reifegradbestimmung nach KHZG"
			type="link"
			to="assessment">

		</NavigationItem>
</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import NavigationItem from "@/components/elements/NavigationItem"
	// import AssessmentNavigationItem from "@/components/elements/AssessmentNavigationItem"
	// import NavigationItem from "@/components/elements/NavigationItem"
	export default {
		name: "AssessmentNavigation", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		components: {
			NavigationItem,
			// AssessmentNavigationItem,
			// NavigationItem
		},
		computed: {
			...Vuex.mapState({
				assessments: state => state.assessments,
				settings: state => state.assessmentSettings
			}),
			// inAssessment(){

			// 	return this.$route.path == "/assessment"
			// },
			assessment(){
				return this.assessments[0]
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>